export class DataResult {
  anzahlMaGesamt: number;
  anzahlMaGesamtWeiblich: number;
  anzahlMaGesamtMaennlich: number;
  prozentMaGesamtWeiblich: string;
  prozentMaGesamtMaennlich: string;
  anzahlFuerAnalyseBeruecksichtigteMa: number;
  anzahlFuerAnalyseBeruecksichtigteMaWeiblich: number;
  anzahlFuerAnalyseBeruecksichtigteMaMaennlich: number;
  anzahlFuerAnalyseBeruecksichtigteMaProzentMaennlich: string;
  anzahlFuerAnalyseBeruecksichtigteMaProzentWeiblich: string;
  durchschnittslohndifferenzBetrag: number;
  durchschnittslohndifferenzAbweichungInProzent: string;
  durchschnittslohndifferenzFrauenVerdienenWeniger: boolean;
  unerklaerteGeschlechterspezifischeLohndifferenzAbweichungProzent: string;
  unerklaerteGeschlechterspezifischeLohndifferenzFrauenVerdienenWeniger: boolean;
  unerklaerteGeschlechterspezifischeLohndifferenzBewertungsstufe: number;
  zusammenfassungTextKategorie: number;

  anzahlMaGueltig: number;
  anzahlFrauenGueltig: number;
  anzahlMaennerGueltig: number;
  anzahlMaUngueltig: number;
  anzahlFrauenUngueltig: number;
  anzahlMaennerUngueltig: number;
  anzahlMaAusgeschlossen: number;
  anzahlFrauenAusgeschlossen: number;
  anzahlMaennerAusgeschlossen: number;
}

export class DataResultM2 {
  anzahlMaGesamt: number;
  anzahlMaGesamtWeiblich: number;
  anzahlMaGesamtMaennlich: number;
  anzahlFuerAnalyseBeruecksichtigteMa: number;
  anzahlFuerAnalyseBeruecksichtigteMaWeiblich: number;
  anzahlFuerAnalyseBeruecksichtigteMaMaennlich: number;
  anzahlFuerAnalyseBeruecksichtigteMaProzentWeiblich: string;
  anzahlFuerAnalyseBeruecksichtigteMaProzentMaennlich: string;
  prozentMaGesamtWeiblich: string;
  prozentMaGesamtMaennlich: string;
  risikopaareZuUngunstenMaenner: number;
  risikopaareZuUngunstenFrauen: number;
  durchschnittslohndifferenzZuUngunstenMaenner: string;
  durchschnittslohndifferenzZuUngunstenFrauen: string;
  risikogewichtZuUngunstenMaenner: number;
  risikogewichtZuUngunstenFrauen: number;
  anzahlPaareMoeglich: number;
  anzahlRisikopaare: number;
  anteilRisikopaare: string;
  gesamtscore: number;
  robustscore: number;
  zuUngunstenFrauen?: boolean;
  risikostufe: number;
}
